import classNames from "classnames"

export interface Props {
  rating: number
  text: string
  className?: string
  textColor?: string
}

const StarIcon = ({ filled }: { filled: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-3 h-3 md:w-4 md:h-4"
    viewBox="0 0 24 24"
    fill={filled ? "#F97316" : "none"}
    stroke="#F97316"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
)

const StarRating = ({ rating, text, className, textColor }: Props) => {
  const clampedRating = Math.min(5, Math.max(0, Math.round(rating)))

  return (
    <div className={classNames("inline-flex items-center gap-2", className)}>
      <div
        className="flex items-center gap-0.5"
        aria-label={`${clampedRating} out of 5 stars`}
      >
        {Array.from({ length: 5 }, (_, i) => (
          <StarIcon key={i} filled={i < clampedRating} />
        ))}
      </div>
      <span
        className="text-xs uppercase"
        style={{ color: textColor ?? "#585958" }}
      >
        {text}
      </span>
    </div>
  )
}

StarRating.displayName = "StarRating"

export { StarRating }
export default StarRating
